import { styled, TableCell, tableCellClasses, Typography } from "@mui/material";

function createTableColsData(title, id, type) {
  return { title, id, type };
}
export const tabArr = [
  { text: "Firmware", value: "firmware" },
  { text: "Pilot App", value: "pilotApp" },
];
export const firmwareTableCols = [
  createTableColsData("Link", "link", "link"),
  createTableColsData("Version", "version", "version"),
  createTableColsData("Hash", "hash", "textarea"),
  createTableColsData("Live", "latest", "live"),
];
export const appTableCols = [
  createTableColsData("Link", "link", "link"),
  createTableColsData("Version", "version", "version"),
  createTableColsData("Hash", "hash", "textarea"),
  // createTableColsData("Hash", "hash", "textarea"),
  createTableColsData("Live", "latest", "live"),
];

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#f4f4f5",
    color: "#51555C",
    border: 0,
    ...theme.typography.h5,
    width: "50%",
    maxWidth: 400,
    minWidth: 100,
    whiteSpace: "normal",
    overflow: "auto",
    wordBreak: "break-word",

    [`&.MuiTableCell-paddingCheckbox`]: {
      paddingLeft: 12,
      paddingRight: 0,
    },
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    width: 0,
    maxWidth: 400,
    minWidth: 100,
    whiteSpace: "normal",
    overflow: "auto",
    wordBreak: "break-word",
    border: 0,
    verticalAlign: "baseline",
    [`&.MuiTableCell-paddingCheckbox`]: {
      paddingLeft: 12,
      paddingRight: 0,
    },
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: "#ffffff",
    padding: "10px 15px",
    position: "sticky",
    bottom: -1,
    borderTop: "1px solid #dcdee0",
    borderBottom: "0px solid #dcdee0",
  },
}));

export const noData = (
  <Typography sx={{ color: "#A0A4AB" }}>No Data</Typography>
);
